import { mapServerSideMediaObject } from '@/utils/api.mapper'
import { getInstanceWithToken } from '@/utils/axios'
import { MediaObject, ServerSideMediaObject } from './types'

export const uploadMediaObject = async (file: File | Blob): Promise<MediaObject> => {
  const request = new FormData()
  request.append('file', file)

  const { data } = await getInstanceWithToken().post<ServerSideMediaObject>(
    '/api/media_objects',
    request
  )

  return mapServerSideMediaObject(data)
}

export default uploadMediaObject
